const config = {
    websiteName: process.env.REACT_APP_WEBSITE_NAME,
    baseUrl: process.env.REACT_APP_BASE_URL,
    supportEmail: process.env.REACT_APP_SUPPORT_EMAIL,
    appVersion: process.env.REACT_APP_APP_VERSION,
    showFreeMonth: process.env.REACT_APP_SHOW_FREE_MONTH === 'true',
    signInUrl: process.env.REACT_APP_SIGNIN_URL,
    signUpUrl: process.env.REACT_APP_SIGNUP_URL,
  };
  
  export default config;